import { createAsyncThunk } from "@reduxjs/toolkit"
import { setAllowedParticipants, setOwners } from "../owners/ownerSlice"
import axios from "axios"

const typePrefix = 'app/fetchParticipants'

export const fetchParticipants = createAsyncThunk(
  typePrefix,
  async ({ unique_owner_id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get('/api/messaging/allowed_participants', {
        params: { unique_owner_id }
      })
      const { my_allowed_groups, my_allowed_users } = response?.data

      dispatch(setAllowedParticipants({ id: unique_owner_id, data: { my_allowed_groups, my_allowed_users } }))
      return response?.data
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)
